import { AddVehicleWizard } from "@/components/organisms/Vehicles/AddVehicle/AddVehicleWizard";

export const AddVehicle = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <AddVehicleWizard />
    </div>
  );
};
